import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '100%',
    height: '100%'
  },

  mobileRole: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '100%',
    height: '100%',
    '@media (max-width: 959px)': {
      //mobile botom nav bar height
      height: ' calc(100% - 40px)'
    }
  },

  children: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: '80svh',
    paddingRight: '1.5rem',
    overflow: 'hidden auto'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
    borderBottom: '0.125rem solid #F1F1F1',
    boxSizing: 'border-box',
    paddingBottom: '1.5rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  }
}))

export default useStyles
